<template>
  <div v-if="loadingList">
    <AppSkeletonTable></AppSkeletonTable>
  </div>
  <div v-else>
    <DataTable :value="results" responsiveLayout="stack">
      <Column header="Nome" field="name" :sortable="true"> </Column>
      <Column header="Texto" field="text" :sortable="true"> </Column>
      <Column header="Logo 1">
        <template #body="props">
          <div class="image-container">
            <img
              v-if="getImageUrl(props.data, 1)"
              :src="getImageUrl(props.data, 1)"
            />
            <span v-else class="material-icons">image</span>
          </div>
        </template>
      </Column>
      <Column header="Logo 2">
        <template #body="props">
          <div class="image-container">
            <img
              v-if="getImageUrl(props.data, 2)"
              :src="getImageUrl(props.data, 2)"
            />
            <span v-else class="material-icons">image</span>
          </div>
        </template>
      </Column>
      <Column header="Ações" alignFrozen="right" :frozen="true">
        <template #body="{ data: { id } }">
          <div>
            <router-link
              :to="{ name: 'report-template.edit', params: { id } }"
              style="text-decoration: none"
            >
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-text p-button-secondary p-mr-1"
              ></Button>
            </router-link>
            <Button
              type="button"
              icon="pi pi-trash"
              class="p-button-text p-button-secondary"
              @click="showDeleteConfirm(results, id, 'name')"
            ></Button>
          </div>
        </template>
      </Column>
    </DataTable>
    <Paginator
      :rows="query.pageSize"
      :totalRecords="pagination.total"
      @page="changeListPage({ page: $event.page + 1 })"
    ></Paginator>
    <router-link
      :to="{ name: 'report-template.create' }"
      style="text-decoration: none"
    >
      <AppFloatButton icon="pi pi-plus" />
    </router-link>
    <AppModalDelete
      type="Modelo de Relatório"
      :visible="deleteConfirm.visible"
      :item="deleteConfirm.item"
      @confirm="onDelete()"
      @cancel="hideDeleteConfirm()"
    ></AppModalDelete>
  </div>
</template>

<script>
import { ReportTemplateApi } from '../../services/api';
import useApiList from '../../lib/useApiList';
import useDeleteConfirm from '../../lib/useDeleteConfirm';

export default {
  name: 'ReportTemplateList',
  setup() {
    return {
      ...useApiList(ReportTemplateApi),
      ...useDeleteConfirm(),
    };
  },
  async created() {
    await this.fetchList();
  },
  methods: {
    getImageUrl(data, position) {
      return data.images.find((img) => img.position === position)?.file?.url;
    },
    onDelete() {
      this.deleteListItem(this.deleteConfirm.id);
      this.hideDeleteConfirm();
    },
  },
};
</script>

<style scoped>
.image-container {
  width: 180px;
  height: 95px;
  border: 1px solid #ced4da;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container img {
  max-width: 95%;
  max-height: 95%;
  object-fit: contain;
}

.image-container .material-icons {
  color: #ced4da;
}
</style>
